import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutReviewSubmitComponent, CheckoutStepService } from '@spartacus/checkout/base/components';
import {
  CheckoutDeliveryAddressFacade,
  CheckoutDeliveryModesFacade,
  CheckoutPaymentFacade, CheckoutQueryFacade,
  CheckoutStep
} from '@spartacus/checkout/base/root';
import { Address, PaymentDetails, QueryState, TranslationService } from '@spartacus/core';
import { Card } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CustomCheckoutStepType,
  customCheckoutPaymentSteps,
} from 'src/app/spartacus/features/tracking/custom-events/checkout/checkout-steps/custom-checkout-steps.model';
import { firstnameLastnameFormatter } from '../../../../../../custom/formatter/firstname-lastname-formatter';

@Component({
  selector: 'app-custom-review-submit',
  templateUrl: './custom-review-detail.component.html',
  styleUrls: ['./custom-review-submit.component.scss'],
  standalone: false
})
export class CustomReviewSubmitComponent extends CheckoutReviewSubmitComponent {
  checkoutStepTypeShippingAddress = CustomCheckoutStepType.SHIPPING_ADDRESS;
  customCheckoutStepTypePaymentDetails = CustomCheckoutStepType.PAYMENT_DETAILS;
  customCheckoutStepTypeDeliveryMode = CustomCheckoutStepType.DELIVERY_MODE;
  customCheckoutStepTypeReviewOrder = CustomCheckoutStepType.REVIEW_ORDER;
  customCheckoutStepTypePaymentType = CustomCheckoutStepType.PAYMENT_TYPE;

  cardPaymentMethod$: Observable<Card>;

  getDeliveryAddress$: Observable<QueryState<Address | undefined>> = this.checkoutDeliveryAddressFacade.getDeliveryAddressState();
  getPaymentDetails$: Observable<QueryState<PaymentDetails | undefined>> = this.checkoutPaymentFacade.getPaymentDetailsState();

  paymentDetails$: Observable<any | undefined> =
    this.checkoutQueryFacade.getCheckoutDetailsState().pipe(
      // filter((state) => !state.loading && !state.error),
      map((state: any) => {
        return state.data?.paymentAddress;
      })
    );

  constructor(
    protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    protected checkoutPaymentFacade: CheckoutPaymentFacade,
    protected activeCartFacade: ActiveCartFacade,
    protected translationService: TranslationService,
    protected checkoutStepService: CheckoutStepService,
    protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    protected store: Store,
    protected checkoutQueryFacade: CheckoutQueryFacade,
  ) {
    super(checkoutDeliveryAddressFacade, checkoutPaymentFacade, activeCartFacade, translationService, checkoutStepService, checkoutDeliveryModesFacade);
  }

  getShippingAddressCard(
    deliveryAddress: Address,
    countryName: string
  ): Observable<Card> {
    return this.translationService.translate('addressCard.shipTo').pipe(
      map((textTitle) => {
        if (!countryName) {
          countryName = deliveryAddress?.country?.isocode as string;
        }

        let region = '';
        if (
          deliveryAddress &&
          deliveryAddress?.region &&
          deliveryAddress?.region?.isocode
        ) {
          region = deliveryAddress?.region?.isocode + ', ';
        }

        return {
          title: textTitle,
          textBold: firstnameLastnameFormatter(deliveryAddress),
          text: [
            deliveryAddress?.line1,
            deliveryAddress?.line2,
            deliveryAddress?.town + ', ' + deliveryAddress?.postalCode
          ],
        } as Card;
      })
    );
  }

  getPaymentMethodCard(paymentDetails: any): Observable<Card> {
    return this.cardPaymentMethod$ = of({
      textBold: firstnameLastnameFormatter(paymentDetails),
      text: [
        paymentDetails?.line1,
        paymentDetails?.line2,
        paymentDetails?.town + ', ' + paymentDetails?.postalCode
      ],
    });
  }

  shippingSteps(steps: CheckoutStep[]): CheckoutStep[] {
    return steps.filter((step) => this.checkoutStepTypeShippingAddress.includes(step.type[0]));
  }

  customPaymentSteps(steps: CheckoutStep[]): CheckoutStep[] {
    return steps.filter((step) => customCheckoutPaymentSteps.includes(step.type[0]));
  }

}
